/**
 * Error types
 */
export var ErrorType;
(function (ErrorType) {
    ErrorType[ErrorType["Error"] = 0] = "Error";
    ErrorType[ErrorType["Alert"] = 1] = "Alert";
})(ErrorType || (ErrorType = {}));
